import React, { useEffect, useRef, useState } from "react";
import CommonInput from "../../../CommonMethhods/CommonInput";
import { Hni_Admin_Api, Lead_Creation } from "../../../Configuration/API_URL";
import axios from "axios";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../../CommonMethhods/CommonMethods";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import CommonSelect from "../../../CommonMethhods/CommonSelect";
import { Modal } from "react-bootstrap";
import { useResumeContext } from "../../../CommonMethhods/Context";
import { useClientContext } from "../../../context/ClientContext";

function BrokerageDetails(props) {
  const IndiMobileNo = localStorage.getItem("IndiMobileNo");
  const storeToken = localStorage.getItem("ssoToken");
  const resumeVal = props?.resumeVal;
  const [allPackData, setAllPackData] = useState([]);
  const { resumeHandle } = useResumeContext();
  const activeTab = props?.activeTab;
  const { selectedClient, shouldPrefill } = useClientContext();
  const [isDetailsSaved, setIsDetailsSaved] = useState(false);


  const errorSchema = Yup.object().shape({
    deliveryValid: Yup.string().required("Delivery is required"),
    intradayValid: Yup.string().required("Intraday is required"),
    futuresValid: Yup.string().required("Futures is required"),
    optionsValid: Yup.string().required("Options are required"),
  });

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    reset: resetForm,
    formState: { errors, isDirty, isValid },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(errorSchema),
  });

  const getAllPackDetails = async () => {
    try {
      const getPackData = await axios.get(Hni_Admin_Api.getPackDetails, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${storeToken}`,
          reserv: 1,
        },
      });

      const res = ApiResDecrypt(getPackData?.data);

      console.log(res, "resOption");
      
      if (res?.status === 0) {
        const rawData = res?.data;

        const formattedData = Object.fromEntries(
          Object.entries(rawData).map(([key, arr]) => [
            key,
            arr.map((val) => ({ name: val })),
          ])
        );
        setAllPackData(formattedData);
      }
    } catch (error) {
      if (error?.request?.status == 401) {
        localStorage.clear("");
        // navigate("/");
      }
    }
  };

  useEffect(() => {
    getAllPackDetails();
  }, []);  

  const insertBrokerageDetails = async (data) => {
    let payloadValue = {
      mobileNo: IndiMobileNo || resumeVal?.verificationDetails?.mobileNo,
      delivery: data?.deliveryValid,
      intraday: data?.intradayValid,
      futures: data?.futuresValid,
      options: data?.optionsValid,
    };

    console.log(payloadValue, "payloadValue");

    let encPayload = AESEncryption(payloadValue);
    try {
      const getRelation = await axios.post(
        Lead_Creation.brokerage_Details,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getRelation?.data);
      if (res?.status === 0) {
        resumeHandle();
        toast.success(res?.data);
        setIsDetailsSaved(true);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const finalSubmit = (data) => {
    console.log("finalsubmit", data);
    if (IndiMobileNo !== null || resumeVal?.verificationDetails?.mobileNo !== "") {
      insertBrokerageDetails(data);
    }
  };

  useEffect(() => {
    const subscription = watch(() => {
      setIsDetailsSaved(false);
    });
    return () => subscription.unsubscribe();
  }, [watch]);


  useEffect(() => {
    if (activeTab !== "individual") {
      resetForm({
        deliveryValid: "",
        intradayValid: "",
        futuresValid: "",
        optionsValid: "",
      });
    } else if (
      shouldPrefill &&
      selectedClient?.mobile &&
      resumeVal?.brokerageDetails
    ) {
      resetForm({
        deliveryValid: resumeVal?.brokerageDetails?.delivery || "",
        intradayValid: resumeVal?.brokerageDetails?.intraday || "",
        futuresValid: resumeVal?.brokerageDetails?.futures || "",
        optionsValid: resumeVal?.brokerageDetails?.options || "",
      });
    }
  }, [
    activeTab,
    shouldPrefill,
    selectedClient?.mobile,
    resumeVal,
  ]);

    console.log(allPackData, "allPackData");


  return (

    <div className="row border-parent accordian-section-wrapper">
      <form className="individual-form" onSubmit={handleSubmit(finalSubmit)}>
    <>
        <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
          <CommonSelect
            label="Delivery Brokerage"
            name="deliveryValid"
            options={allPackData?.delivery || []}
            required
            register={register}
            // value={getValues("deliveryValid")}
          />
        <p className="forget-link add-error">
            <span>{errors?.deliveryValid?.message}</span> 
        </p>
        </div>
        <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
          <CommonSelect
            label="Intraday Brokerage"
            name="intradayValid"
            options={allPackData?.intraday || []}
            required
            register={register}
            // value={getValues("intradayValid")}
          />
          <p className="forget-link add-error">
            <span>{errors?.intradayValid?.message}</span> 
        </p>
        </div>
        <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
          <CommonSelect
            label="Future Brokerage"
            name="futuresValid"
            options={allPackData?.futures || []}
            required
            register={register}
            // value={getValues("futuresValid")}
          />
          <p className="forget-link add-error">
            <span>{errors?.futuresValid?.message}</span> 
        </p>
        </div>
        <div className="col-sm-6 col-lg-3 card-accordian individiual-select lead-creation">
          <CommonSelect
            label="Option (Per Lot)"
            name="optionsValid"
            options={allPackData?.options || []}
            required
            register={register}
            // value={getValues("optionsValid")}

          />
          <p className="forget-link add-error">
            <span>{errors?.optionsValid?.message}</span> 
        </p>
        </div>
      <div className="wrap-button">
        <button type="submit" 
        className="val-btn-wrap"
        // className={`val-btn-wrap ${!isDirty || !isValid || isDetailsSaved ? "val-btn-wrap disable-btn" : ""}`}
  // disabled={!isDirty || !isValid || isDetailsSaved}
  >
          Save
        </button>
      </div>
    </>
    </form>
    </div>
  );
}

export default BrokerageDetails;
